import React, { Component } from "react";
import {
  GalleryTypeHeaderTitle,
  ImageItem,
} from "../../../common/statelessView";
import { batch, connect } from "react-redux";
import {
  closeSlider,
  navigateNow,
  resetPage,
} from "../../../../_actions/sidebarSliderActions";
import { wsCopyFromTemplate } from "../../../../_actions/webSocketAction";
import TLDRSwiper from "../../../common/TLDRSwiper";
import { isEmpty } from "lodash";
import { GRAPHICS_SLIDER_PANEL } from "../../constants";
import { StyledMarketPlaceSwiperButton } from "../../../styled/details/stylesDetails";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import { IconButton } from "@chakra-ui/react";

class TemplateCategorySlider extends Component {
  render() {
    const {
      title,
      data = [],
      artBoardHandler,
      className,
      itemWidth,
      spaceBetween,
    } = this.props;

    let childElements = [];

    if (!isEmpty(data) && Array.isArray(data)) {
      childElements = data.map((image) => {
        return (
          <div
            key={image.id}
            className={className}
            onClick={() => this.handleClick(image)}
          >
            <ImageItem
              data={this.preparePayload(image)}
              key={image.id}
              url={image.image}
              alt={image.description}
              width={image?.image_width}
              height={
                this.props.panelType === GRAPHICS_SLIDER_PANEL
                  ? image.image_width
                  : image?.image_height
              } //to make or flexible at places
              source={image.source}
              type={image.type}
              itemWidth={itemWidth}
              showOverlayInfo={false}
              isUsedInSwiper={false}
            />
          </div>
        );
      });
    }

    const swiperParams = {
      spaceBetween: spaceBetween,
      slidesPerView: 3,
      noSwiping: true,
      freeMode: true,
      shouldSwiperUpdate: true,
      runCallbacksOnInit: true,
      containerClass: "element-swiper-container show-on-hover",
      mousewheel: false,
      lazy: false,
      preloadImages: false,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
        disabledClass: "swiper-button-disabled",
      },
      renderPrevButton: () => (
        <StyledMarketPlaceSwiperButton
          className="swiper-button-prev"
          variance="left"
        >
          <IconButton icon={<FaChevronLeft />} isRound minW={7} height={7} />
        </StyledMarketPlaceSwiperButton>
      ),
      renderNextButton: () => (
        <StyledMarketPlaceSwiperButton
          className="swiper-button-next"
          variance="right"
        >
          <IconButton icon={<FaChevronRight />} isRound minW={7} height={7} />
        </StyledMarketPlaceSwiperButton>
      ),
    };

    return (
      <>
        <GalleryTypeHeaderTitle title={title} toggleMore={this.toggleMore} />
        <TLDRSwiper
          swiperParams={swiperParams}
          artBoardHandler={artBoardHandler}
        >
          {childElements}
        </TLDRSwiper>
      </>
    );
  }

  componentDidMount() {}

  componentWillUnmount() {}

  preparePayload = (data) => {
    let imageWidth = data.image_width;
    let imageHeight = data.image_height;

    if (imageWidth <= 0 || imageHeight <= 0) {
    }

    const message = {
      mime: "shape",
      type: "component",
      content: {
        meta: {
          ...data,
        },
      },
    };
    return message;
  };

  addLayer = (data) => {
    this.props.wsCopyFromTemplate(this.props.editor.activePage.id, data.id);
  };

  toggleMore = (event) => {
    batch(() => {
      this.props.resetPage(this.props.sidebarSlider.searchText);
      this.props.navigateNow({
        categoryType: this.props.categoryType,
        categoryId: this.props.categoryId,
      });
    });
  };

  handleClick = (data) => {
    this.addLayer(data);
    if (this.props.isMobileView) {
      this.props.closeSlider();
    }
  };
}

TemplateCategorySlider.propTypes = {};
TemplateCategorySlider.defaultProps = {
  className: "template-item",
  itemWidth: 80.656,
  spaceBetween: 6,
};

const mapStateToProps = (state) => ({
  sidebarSlider: state.sidebarSlider,
  panelType: state.sidebarSlider.sliderPanelType,
  editor: state.editor,
  isMobileView: state.app.isMobileView,
});

const mapDispatchToProps = (dispatch) => ({
  wsCopyFromTemplate: (activePageId, payload) =>
    dispatch(wsCopyFromTemplate(activePageId, payload)),
  closeSlider: () => dispatch(closeSlider()),
  navigateNow: (payload) => dispatch(navigateNow(payload)),
  resetPage: (payload) => dispatch(resetPage(payload)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TemplateCategorySlider);
